import ScrollHint from 'scroll-hint';
window.addEventListener('load', function(e) {
  if ($('.jsScrollable').length) {
    new ScrollHint('.jsScrollable', {
      i18n: {
        scrollable: 'スクロール'
      },
      remainingTime: 5000,
      suggestiveShadow: true,
    });

    //sticky table has scroll hint
    let stickyTbl = $('.jsStickyTbl');
    if (!$('body').hasClass('ieMode')) {
      $(stickyTbl).each(function() {
        if ($(this).hasClass('is-scrollable')) {
          var iconHint = $(this).children('.scroll-hint-icon-wrap'),
            iconHintClone = iconHint.clone().addClass('activeHint');
          iconHintClone.insertAfter($(this));
          iconHint.hide();
          document.querySelectorAll('.activeHint').forEach((i) => {
            if (i) {
              const observer = new IntersectionObserver((entries) => {
                observerCallback(entries, observer, i)
              }, {
                threshold: 0
              });
              observer.observe(i);
            }
          })
          const observerCallback = (entries, observer, header) => {
            entries.forEach((entry, i) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-active');
                setTimeout(function() {
                  iconHintClone.removeClass('is-active');
                }, 5000);
                $(this).on('scroll', function() {
                  iconHintClone.removeClass('is-active');
                });
              } else {
                entry.target.classList.remove('is-active');
              }
            });
          };
        }
      })
    }
  }
});